export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14081.b9349a41.jpg";